import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MessageSquarePlus } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useUpdateRequests } from '../../../hooks/useEqmsDocuments';
import { EQMS_PENDING_UPDATE_REQUEST_STATUSES } from '../../../types/eqms.types';
import { UPDATE_REQUEST_STATUS_STYLES } from './statusStyles';

/** Keeps the owner's pending requests in view while they edit the revision. */
export function AuthoringUpdateRequestsPanel({ documentId }: { documentId: string }) {
  const { t } = useTranslation('qms');
  const query = useUpdateRequests({ scope: 'owner', documentId, status: [...EQMS_PENDING_UPDATE_REQUEST_STATUSES] });
  const requests = query.data?.requests ?? [];
  if (!requests.length) return null;
  return (
    <details open className="mb-4 rounded-lg border border-amber-200 bg-amber-50/70 p-4 text-sm text-amber-950">
      <summary className="flex cursor-pointer select-none items-center gap-2 font-medium">
        <MessageSquarePlus className="h-4 w-4" />
        {t('updateRequests.revisionPending')} ({requests.length})
      </summary>
      <ul className="mt-3 space-y-2">
        {requests.map((request) => (
          <li key={request.id} className="rounded-md bg-white p-3 text-slate-800">
            <span className={cn('mr-2 inline-block rounded border px-1.5 text-[11px]', UPDATE_REQUEST_STATUS_STYLES[request.status])}>
              {t(`updateRequests.status.${request.status}`)}
            </span>
            <span className="font-medium">{request.requesterName}</span>
            <p className="mt-1 whitespace-pre-wrap break-words">{request.reason}</p>
          </li>
        ))}
      </ul>
      <p className="mt-3 text-xs">
        {t('updateRequests.autoClose')}{' '}
        <Link className="underline" to={`/eqms?document=${encodeURIComponent(documentId)}&tab=update-requests`}>
          {t('updateRequests.actions.openDocument')}
        </Link>
      </p>
    </details>
  );
}
